module.exports = __webpack_public_path__ + "static/b7-ee24373a65c65be19584dd12a7767008.jpg";